module.exports = __webpack_public_path__ + "assets/img/22_1334.9d51d4fb.jpg";